import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import tableIcons from "../../../components/tableicon/table-icons";
import TabPanel from "../../../components/TabPanel";
import MaterialTable from "material-table";

function TopSeller({ value }) {
  const { profil } = useData();
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState({
    columns: [
      { title: "Nama", field: "nama" },
      { title: "Periode", field: "bulan" },
      { title: "Sales Langsung", field: "total_sales" },
    ],
    data: [],
  });

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getTopSeller");

      const res = await func({ user_id: profil.id });

      setTable((table) => {
        return {
          ...table,
          data: res?.data.map((doc) => {
            return {
              ...doc,
              nama: doc.nama,
              bulan: doc.bulan,
              total_sales: doc.total_sales,
            };
          }),
        };
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TabPanel value={value} index="seller">
        <MaterialTable
          columns={table.columns}
          data={table.data}
          title="Daftar Seller"
          icons={tableIcons}
          components={{
            Container: (props) => <div {...props} elevation={0} />,
          }}
          localization={{
            body: {
              emptyDataSourceMessage: "Tidak Ada Data",
            },
            toolbar: {
              searchTooltip: "Cari",
              searchPlaceholder: "Cari Data",
            },
            header: {
              actions: "Actions",
            },
            pagination: {
              labelRowsSelect: "Baris",
              labelDisplayedRows: " {from}-{to} Dari {count} Baris",
              firstTooltip: "Halaman Pertama",
              previousTooltip: "Halaman Sebelumnya",
              nextTooltip: "Halaman Selanjutnya",
              lastTooltip: "Halaman Terakhir",
            },
          }}
        />
    </TabPanel>
  );
}

export default TopSeller;
